import { createSlice } from "@reduxjs/toolkit";

import { REHYDRATE } from 'redux-persist/es/constants';

const initialState = {
    landingIsActive: true,
    dashBoardIsActive: false,
    navBarIsActive: false,
    newIsActive: false,
    viewingAreaIsActive: false,
    recommendedIsActive: false,
    signUpLoginIsActive: false,
    activeMedia: null,
    activeWatch: null,
    activeRead: null,
    activeLearn: null,
    searchIsActive: false,
    searchTerm: "",
    searchFilterType: "watches",
    searchOrderByNewest: true,
    searchOrderByOldest: false
}

export const activeSlice = createSlice({
    name: "active", //?
    initialState,
    reducers:{
        activeReset: (state) => initialState,
        activeMediaReset: (state) => {
            state.activeWatch = null;
            state.activeLearn = null;
            state.activeRead = null;
        },
        setDashBoardIsActive: (state) =>{
            state.signUpLoginIsActive = false;
            state.landingIsActive = false;
            state.dashBoardIsActive = true;
            state.searchIsActive = false;
        },
        setLandingIsActive: (state) =>{
            state.signUpLoginIsActive = false;
            state.landingIsActive = true;
            state.dashBoardIsActive = false;
            state.searchIsActive = false;
        },
        setSearchIsActive: (state) =>{
            state.signUpLoginIsActive = false;
            state.landingIsActive = false;
            state.dashBoardIsActive = false;
            state.searchIsActive = true;
        },
        setActiveMedia: (state, action) =>{
            state.activeMedia = action.payload
        },
        setActiveWatch: (state, action) =>{
            state.activeWatch = action.payload
        },
        setActiveLearn: (state, action) =>{
            state.activeLearn= action.payload
        },
        setActiveRead: (state, action) =>{
            state.activeRead = action.payload
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setSearchFilterType: (state, action) =>{
            state.searchFilterType = action.payload;
        },
        setOrderByNewest: (state ) =>{
            state.searchOrderByNewest = true;
            state.searchOrderByOldest = false
        },
        setOrderByOldest: (state ) =>{
            state.searchOrderByNewest = false;
            state.searchOrderByOldest = true
        },
        [REHYDRATE]: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        }
    },
})

export const {
    activeReset,
    setDashBoardIsActive,
    setActiveWatch,
    setActiveRead,
    setActiveLearn,
    activeMediaReset,
    setActiveMedia,
    setSearchIsActive,
    setSearchTerm,
    setSearchFilterType,
    setOrderByNewest,
    setOrderByOldest,
    setLandingIsActive
} = activeSlice.actions;

export default activeSlice.reducer;
